import { render, staticRenderFns } from "./BuyButtonContainer.vue?vue&type=template&id=5db9d05d&"
import script from "./BuyButtonContainer.vue?vue&type=script&lang=ts&"
export * from "./BuyButtonContainer.vue?vue&type=script&lang=ts&"
import style0 from "./BuyButtonContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports